import ClickEventTargetManager from '../ClickEventTargetManager';
import TrackSearchResults from './TrackSearchResults';

export default class SearchClickEventTargetManager extends ClickEventTargetManager {
    protected override handleEvent(event: Event, element: HTMLElement): void {
        if (event.target && ['A', 'IMG'].includes((event.target as HTMLElement).tagName)) {
            TrackSearchResults.trackSelectItem(element as HTMLAnchorElement);
        }
        super.handleEvent(event, element);
    }
}
